import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { publicApi, bannerUrl } from '../../lib/api';
import { Dialog, DialogContent } from '../ui/dialog';
import { Button } from '../ui/button';
import { X, ArrowRight } from 'lucide-react';

export default function PopupManager() {
  const location = useLocation();
  const [popup, setPopup] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setPopup(null);
    setOpen(false);
    // Ignore admin routes
    if (location.pathname.startsWith('/admin')) return;
    let cancelled = false;
    publicApi.getPopup(location.pathname).then((items) => {
      if (cancelled || !items || !items.length) return;
      const p = items[0];
      const dismissed = localStorage.getItem(`taa_popup_${p.id}`);
      if (dismissed) return;
      setPopup(p);
      setTimeout(() => setOpen(true), 800);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [location.pathname]);

  const dismiss = () => {
    if (popup) localStorage.setItem(`taa_popup_${popup.id}`, '1');
    setOpen(false);
  };

  if (!popup) return null;

  const handleCta = () => {
    if (popup.cta_url) {
      window.open(popup.cta_url, '_blank', 'noopener');
    }
    dismiss();
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) dismiss(); else setOpen(true); }}>
      <DialogContent className="max-w-lg p-0 overflow-hidden border-emerald-100">
        <button onClick={dismiss} className="absolute right-3 top-3 z-10 w-8 h-8 rounded-full bg-white/90 hover:bg-white flex items-center justify-center shadow border border-slate-200">
          <X className="w-4 h-4 text-slate-700" />
        </button>
        {popup.image_url && (
          <button onClick={handleCta} className="block w-full relative h-48 overflow-hidden bg-gradient-to-br from-emerald-50 to-teal-50">
            <img
              src={bannerUrl(popup.image_url)}
              alt=""
              aria-hidden="true"
              className="absolute inset-0 w-full h-full object-cover scale-110 blur-xl opacity-50"
            />
            <img src={bannerUrl(popup.image_url)} alt={popup.title} className="relative w-full h-full object-contain object-center p-3 cursor-pointer" />
          </button>
        )}
        <div className="p-6">
          <h3 className="font-serif-display text-2xl font-bold text-slate-900">{popup.title}</h3>
          {popup.description && <p className="mt-2 text-slate-600 text-sm leading-relaxed">{popup.description}</p>}
          <div className="mt-5 flex items-center gap-3">
            <Button onClick={handleCta} className="bg-emerald-600 hover:bg-emerald-700 text-white h-11 px-6 group">
              {popup.cta_label || 'Learn More'}
              <ArrowRight className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </Button>
            <button onClick={dismiss} className="text-slate-500 hover:text-slate-700 text-sm">No thanks</button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
